import styled from 'styled-components';

export const Container = styled.div`
	border: solid 1px #818181;
	border-radius: 8px;
	padding: 20px;
	width: 100%;
	min-width: 100%;
	margin-bottom: 20px;
	padding-bottom: 0px;

	.title {
		display: flex;
		justify-content: space-between;

		h2 {
			font-size: min(15px, 1.5vw);
		}

		.img {
			transform: rotate(0deg);
			transition: all 0.3s;

			&:hover {
				cursor: pointer;
			}
		}
		.rotate {
			transform: rotate(180deg);
			transition: all 0.3s;
		}
	}
	p {
		color: #707070;
		font-size: 12px;
		height: max-content;
		transition: all 0.3s;
		margin-bottom: 22px;

		word-break: break-word;
		padding-bottom: 20px;
	}
`;
